// Simple regex to ensure we have an @ and a valid domain
const validEmail = /\S+@\S+\.\S+/;

export function isValidEmail(input?: string): boolean {
  return validEmail.test(input ?? '');
}
